import ClipButton from "./ClipButton";

export default ClipButton;
